import { ChangeDetectionStrategy, OnChanges } from '@angular/core';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ChipFilterList } from '@app-models/list-chip-filter';
import * as _ from 'lodash';

@Component({
  selector: 'app-chip-filter',
  templateUrl: './chip-filter.component.html',
  styleUrls: ['./chip-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipFilterComponent implements OnInit, OnChanges {
  @Input() filterList: ChipFilterList[];

  @Output() output = new EventEmitter<any>();

  @Input() selectedFilter = '';
  @Input() filter = '';
  @Input() habilitarcheck = true;

  chipList: ChipFilterList[] = [];
  menuList: ChipFilterList[] = [];

  ngOnInit(): void {
    this.chipList = _.filter(this.filterList, (item) => !item.isMenuItem);
    this.menuList = _.filter(this.filterList, (item) => item.isMenuItem);
  }

  ngOnChanges(changes): void {
    if (changes && changes.filterList) {
      this.chipList = _.filter(
        changes.filterList.currentValue,
        (item) => !item.isMenuItem
      );
      this.menuList = _.filter(
        changes.filterList.currentValue,
        (item) => item.isMenuItem
      );
    }
    if (changes && changes.selectedFilter) {
      this.selectedFilter = changes.selectedFilter.currentValue;
    }
    if (changes && changes.filter) {
      this.filter = changes.filter.currentValue;
    }
  }

  applyFilter(item) {
    if (this.habilitarcheck) {
      if (item.state === this.selectedFilter && this.filter) {
        this.selectedFilter = null;
        this.filter = null;
      } else {
        this.filter = item.filter;
        this.selectedFilter = item.state;
      }
      this.output.emit({
        status: this.selectedFilter,
        filter: this.filter,
      });
    }
  }
}
